import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
interface Purchase {
  id: string;
  name: string;
  city: string;
  timeAgo: string;
}
const argentineCities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'San Miguel de Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca', 'Paraná'];
const firstNames = ['María', 'Juan', 'Ana', 'Carlos', 'Laura', 'Diego', 'Sofía', 'Martín', 'Valentina', 'Lucas', 'Camila', 'Mateo', 'Florencia', 'Santiago', 'Lucía'];
const lastNames = ['González', 'Rodríguez', 'Fernández', 'López', 'Martínez', 'García', 'Pérez', 'Sánchez', 'Romero', 'Torres', 'Díaz', 'Álvarez'];
const timeAgoOptions = ['hace 2 minutos', 'hace 5 minutos', 'hace 8 minutos', 'hace 12 minutos', 'hace 15 minutos', 'hace 20 minutos'];
function generateRandomPurchase(): Purchase {
  const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
  const lastNameInitial = lastNames[Math.floor(Math.random() * lastNames.length)][0];
  const city = argentineCities[Math.floor(Math.random() * argentineCities.length)];
  const timeAgo = timeAgoOptions[Math.floor(Math.random() * timeAgoOptions.length)];
  return {
    id: Math.random().toString(36).substr(2, 9),
    name: `${firstName} ${lastNameInitial}.`,
    city,
    timeAgo
  };
}
export function SocialProofPopup() {
  const [currentPurchase, setCurrentPurchase] = useState<Purchase | null>(null);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(generateRandomPurchase());
      // Auto-dismiss after 4 seconds
      setTimeout(() => {
        setCurrentPurchase(null);
      }, 4000);
    };
    // Show first popup after 3 seconds
    const initialTimeout = setTimeout(showPopup, 3000);
    // Then show popup every 10-18 seconds
    const interval = setInterval(() => {
      const randomDelay = 10000 + Math.random() * 8000;
      setTimeout(showPopup, randomDelay);
    }, 18000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-145">
      {currentPurchase && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-6 right-6 z-50 max-w-sm" data-id="element-146">
          <div className="bg-white rounded-xl shadow-2xl border border-stone-200 p-4 flex items-start gap-3" data-id="element-147">
            <div className="flex-shrink-0 w-10 h-10 bg-[#10b981] rounded-full flex items-center justify-center" data-id="element-148">
              <CheckCircle2 className="w-6 h-6 text-white" data-id="element-149" />
            </div>

            <div className="flex-1 min-w-0" data-id="element-150">
              <p className="font-semibold text-stone-900 text-sm" data-id="element-151">
                {currentPurchase.name}
              </p>
              <p className="text-stone-600 text-xs mt-0.5" data-id="element-152">
                de {currentPurchase.city}
              </p>
              <p className="text-stone-500 text-xs mt-1" data-id="element-153">
                Compró la plantilla {currentPurchase.timeAgo}
              </p>
            </div>

            <button onClick={() => setCurrentPurchase(null)} className="flex-shrink-0 text-stone-400 hover:text-stone-600 transition-colors" aria-label="Cerrar" data-id="element-154">
              <X className="w-4 h-4" data-id="element-155" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}